module.exports = "/images/login-icon-account.png?366d22b2d836bbc0bbdac6d0983c356d";